export default __webpack_public_path__ + "img/component-btn.4d129504.png";